import { Button, Card, Col, Row } from 'antd';
import { Mail, Users } from 'lucide-react';
import { whitelabelLandingPageURL } from '../../config';

const Unqualified = () => {
	return (
		<div className="h-screen overflow-y-auto w-full flex flex-col justify-center ">
			<div className="w-[90%] mx-auto p-6">
				<Card className="shadow-2xl rounded-3xl border-0 bg-white/80 backdrop-blur-sm p-1 overflow-hidden mt-5">
					<div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-blue-500 via-purple-500 to-indigo-500" />

					<div className="w-20 h-20 flex items-center justify-center bg-blue-50 rounded-full mx-auto">
						<Users size={30} className="text-blue-500" />
					</div>
					<div className="text-center mt-4">
						<h1 className="text-3xl font-bold text-blue-500 mb-2">Thank You for Your Interest!</h1>
						<p className="text-gray-500 text-sm">
							We've received your application and are excited to learn more about your business
						</p>
					</div>
					<div className="rounded-2xl bg-blue-50 p-4 text-center">
						<Mail size={40} className="text-blue-500 block mx-auto" />
						<h2 className="text-lg font-bold text-blue-500 mb-2 mt-2">What Happens Next?</h2>
						<p className="text-gray-500 text-sm">
							Our team will review your information and reach out within 2-3 business days to
							discuss potential opportunities that align with your current business stage.
						</p>
					</div>

					<Row gutter={16} className="my-4">
						<Col md={12}>
							<div className="rounded-lg border p-3">
								<p className="text-lg font-bold mb-2">Personalized Consultation</p>
								<p className="text-gray-500">
									We'll explore tailored solutions for your specific needs
								</p>
							</div>
						</Col>
						<Col md={12}>
							<div className="rounded-lg border p-3">
								<p className="text-lg font-bold mb-2">Growth Strategy</p>
								<p className="text-gray-500">
									Our experts will help identify opportunities for expansion
								</p>
							</div>
						</Col>
					</Row>

					<p className="text-gray-500 text-center">
						In the meantime, feel free to explore our resources and case studies
					</p>
					<a href={whitelabelLandingPageURL} rel="noreferrer">
						<Button size="large" className="mx-auto block">
							Return to Home
						</Button>
					</a>
				</Card>
			</div>
		</div>
	);
};

export default Unqualified;
